module.exports = (__webpack_public_path__ || '') + "static/images/photo-9-b9f7d32e444523c0671d37ab4a811d41.jpg";